


















































































































import { Component, Prop, Provide, Vue, Watch } from "vue-property-decorator";
import ExpandingTable from "@/components/ExpandingTable.vue";
import CategoriesDataService, {
  ArticleCount,
  CategorySelectorRow,
  CategoryViewDataRow,
  KeywordsForCategoryRow
} from "@/services/CategoriesDataService";
import GraphPanel from "@/components/GraphPanel.vue";
import CategoryIcon from "@/components/CategoryIcon.vue";
import ComparisonButton from "@/components/ComparisonButton.vue";
import StateContainer, { State } from "@/components/StateContainer.vue";
import { LineGraphData } from "@/components/LineGraph.vue";
import LoadingTable from "@/components/LoadingTable.vue";
import BorderedButton from "@/components/BorderedButton.vue";
import PieChart from "@/components/PieChart.vue";
import BaseTable from "@/components/BaseTable.vue";
import SubcategoryColorIcon from "@/components/SubcategoryColorIcon.vue";
import ModableContainer from "@/components/ModableContainer.vue";
import { generateGraphData } from "@/helpers/CategoryHelpers";

@Component({
  components: {
    ModableContainer,
    SubcategoryColorIcon,
    BaseTable,
    PieChart,
    BorderedButton,
    LoadingTable,
    StateContainer,
    ComparisonButton,
    CategoryIcon,
    ExpandingTable,
    GraphPanel
  }
})
export default class Subcategories extends Vue {
  @Prop() private id!: string;
  @Prop() private sid!: string;
  @Provide() private graphState = State.loading;
  @Provide() private articleCounts: ArticleCount[] | null = null;
  @Provide() private graphTitle = "Number of articles indexed in FSTA";
  @Provide() private graphData: LineGraphData[] = [];
  @Provide() private graphTableData: any[] = [];
  @Provide() private showLineGraphModal = false;
  @Provide() dateRange = { start: this.dates.minYear, end: this.dates.maxYear };

  @Provide() keywordState = State.loading;
  @Provide() keywords: KeywordsForCategoryRow[] = [];
  @Provide() journalState = State.loading;
  @Provide() journals: CategoryViewDataRow[] = [];
  @Provide() documentState = State.loading;
  @Provide() documents: CategoryViewDataRow[] = [];
  @Provide() languageState = State.loading;
  @Provide() languages: CategoryViewDataRow[] = [];
  @Provide() category: CategorySelectorRow | null = null;

  @Watch("articleCounts")
  onArticleCountsChanged() {
    this.graphData = generateGraphData(
      this.articleCounts,
      this.category,
      this.dates.maxYear
    );
  }

  @Watch("category")
  onCategoryChanged() {
    this.graphData = generateGraphData(
      this.articleCounts,
      this.category,
      this.dates.maxYear
    );
  }

  get dates() {
    return this.$store.state.config.dates;
  }

  get comparisonLinkParams() {
    return this.category
      ? {
          ids: [],
          sids: [
            {
              parentId: this.category.section_letter,
              id: this.category.subsection_letter,
              field: this.category.subsection_heading
            }
          ],
          dateRange: {
            start: this.dates.minYear,
            end: this.dates.maxYear
          }
        }
      : null;
  }

  retrieveSubcategory() {
    return CategoriesDataService.getCategoryDetails(this.id, this.sid)
      .then(response => {
        this.category = response || null;
      })
      .catch(console.log);
  }

  retrieveArticles() {
    return CategoriesDataService.getArticleCounts(this.id, this.sid)
      .then(response => {
        this.articleCounts = response.data || null;
        this.graphState = State.okay;
      })
      .catch(error => {
        this.graphState = State.error;
        console.log(error);
      });
  }

  retrieveAdditionalData() {
    CategoriesDataService.getKeywords(this.id, this.sid)
      .then(response => {
        this.keywords = response.data.slice(0, 100);
        // TODO work out keyword limit
        this.keywordState = State.okay;
      })
      .catch(e => {
        this.keywordState = State.error;
        console.log(e);
      });

    CategoriesDataService.getJournals(this.id, this.sid)
      .then(response => {
        this.journals = response.data;
        this.journalState = State.okay;
      })
      .catch(e => {
        this.journalState = State.error;
        console.log(e);
      });

    CategoriesDataService.getDocumentTypes(this.id, this.sid)
      .then(response => {
        this.documents = response.data;
        this.documentState = State.okay;
      })
      .catch(e => {
        this.documentState = State.error;
        console.log(e);
      });

    CategoriesDataService.getLanguages(this.id, this.sid)
      .then(response => {
        this.languages = response.data.slice(0, 100);
        // TODO work out limit
        this.languageState = State.okay;
      })
      .catch(e => {
        this.languageState = State.error;
        console.log(e);
      });
  }

  mounted() {
    this.retrieveSubcategory();
    this.retrieveArticles();
    this.retrieveAdditionalData();
  }

  hideGenericKeywords(element: KeywordsForCategoryRow) {
    return !element.generic;
  }

  handleLineGraphModalOpen() {
    this.showLineGraphModal = true;
  }

  handleLineGraphModalClose() {
    this.showLineGraphModal = false;
  }
}
